<template>
  <div>
    <breadcrumb :list="breadcrumbList"></breadcrumb>
    <el-card class="main">
      <!-- 用户卡片 -->
      <div class="userCard">
        <div class="userData">
          <el-row type="flex">
            <el-col class="userImg">
              <img
                v-if="list.image_url"
                :src="list.image_url ? list.image_url : ''"
                alt=""
              />
              <div class="imgError" v-else>暂无图片</div>
            </el-col>
            <el-col style="margin: 15px 0 0 20px">
              <div class="username">{{ list.name }}</div>
              <!-- <div class="csbm">人员编码：{{ list.id }}</div>      -->
            </el-col>
          </el-row>
        </div>
        <img class="illustration" src="@/assets/img/illustration.png" alt="" />
      </div>
      <div class="subject">
      
        <el-descriptions
          class="margin-top"
          :column="3"
          border
          labelClassName="labelWidth"
          contentClassName="contentWidth"
        >
          <el-descriptions-item label="联系电话">{{
            list.mobile
          }}</el-descriptions-item>
          
          <el-descriptions-item label="性别">
            {{ list.sex | xbFilter }}</el-descriptions-item
          >
          <el-descriptions-item label="民族">
            {{ list.nation | mzFilter }}</el-descriptions-item
          >
          <el-descriptions-item label="出生日期">
            {{ list.birthday }}</el-descriptions-item
          >
          <el-descriptions-item label="到店日期">
            {{ list.daodian_time | formatDate }}
          </el-descriptions-item>
          <el-descriptions-item label="常驻地址">
            {{ list.address | dzFilter }}</el-descriptions-item
          >
          <el-descriptions-item label="证件类型">
            {{ list.ids_type | zjlxFilter }}</el-descriptions-item
          >
          <el-descriptions-item label="证件号码">
            {{ list.idcard }}</el-descriptions-item
          >
           
          <!-- <el-descriptions-item label="紧急联系人">
            {{ list.cyry_jjlxr }}</el-descriptions-item
          >
          <el-descriptions-item label="紧急联系人电话">
            {{ list.cyry_jjlxrdh }}</el-descriptions-item
          >
          <el-descriptions-item label="考勤编号">
            {{ list.cyry_jobcard }}</el-descriptions-item
          > -->
        </el-descriptions>
       
      </div>
      <div class="subject_btn" style="text-align: center; margin-top: 18px">
        <!-- <el-button type="info" @click="goBack">返回</el-button>  2020-06-02 产品去掉-->
        <el-button type="primary" @click="$router.back(-1)" class="go_back"
          >返回</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
import {getPointperson_details, getrylb} from '@/api/user'
import { filtersInfo, lists } from '@/utils/dictionary.js'
let that
export default {
  name: 'PointpersonDetailsVue',
  data() {
    return {
      breadcrumbList: [
        // 面包屑所需数据
        { name: '重点关注人员', path: 'pointperson' },
        { name: '查看', path: 'pointperson/pointperson_details' }
      ],
      list: {
        cyry_xp: ''
      },
      zjlx: '', //证件类型
      // 字典
      xxList: [],
      hyzkList: [],
      xbList: [],
      mzList: [],
      gjList: [],
      loading: true
    }
  },
  beforeCreate() {
    that = this
  },
  created() {
    this.info()
  },
  methods: {
    async info() {
      this.list = await getPointperson_details(this.$route.query.id)
      // 获取字典
      this.getSelectList()
    },
    getSelectList() {
      //获取字典
      this.xxList = lists['XX']
      this.hyzkList = lists['HYZK']
      this.xbList = lists['XB']
      this.mzList = lists['NATION'] 
      this.zjlxList = lists['0203']
      // this.rylbList = lists['RYLB']
      getrylb().then(res=>{
        this.rylbList = res
      })
    }
  },
  filters: {
    xxFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.xxList, val)
    },
    hyzkFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.hyzkList, val)
    },
    xbFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.xbList, val)
    },
    zjlxList(val) {
      if (!val && val != 0) return
      return filtersInfo(that.zjlxList, val)
    },
    mzFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.mzList, val)
    },
    sjFilter(val) {
      if (!val && val != 0) return
      // 过滤器业务逻辑，要有返回值
      val = val ? val * 1000 : null
      let date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      return Y + M + D
    },
    sjFilterEncryption(val) {
      if (!val && val != 0) return
      // 过滤器业务逻辑，要有返回值
      val = val ? val * 1000 : null
      let date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M = '**-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      return Y + M + D
    },
    gjFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.gjList, val)
    },
    zylbFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.zylbList, val)
    },
    dzFilter(val) {
      if (!val && val != 0) return
      return val.split('-').reduce((pre, item) => {
        return pre + item
      }, '')
    },
    zjlxFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.zjlxList, val)
    },
    rylbFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.rylbList, val)
    },
    ryztFilter(val) {
      if (!val && val != 0) return
      return filtersInfo(that.ryztList, val)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/pointperson') {
      this.$store.commit('setKeep', '')
    }
    next()
  }
}
</script>

<style lang="less" scoped>
.main {
  margin: 20px;
  padding: 28px 20px;

  .userCard {
    position: relative;
    background: linear-gradient(90deg, #ffffff 0%, #efebff 100%);
    width: 100%;
    height: 228px;
    border: 1px solid #fff;
    border-radius: 8px;

    .userData {
      margin: 85px 0 0 80px;

      .userImg {
        width: 103px;
        height: 103px;
        border-radius: 14px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #747780;
        border: 1px solid #d9dbe0;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .username {
        margin-bottom: 21px;
        font-size: 30px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #6345d5;
      }

      .cs_dmsn {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #747780;
      }
    }

    .illustration {
      width: 518px;
      height: 259px;
      position: absolute;
      bottom: -17px;
      right: 0;
    }
  }

  .subject {
    .subject_title {
      padding: 32px 0 15px 0;

      img {
        width: 30px;
        height: 39px;
        margin-right: 3px;
      }

      .title_text {
        font-size: 18px;
        line-height: 36px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #6345d5;
      }
    }
  }

  /deep/ .labelWidth {
    min-width: 150px;
  }

  /deep/ .contentWidth {
    min-width: 300px;
  }

  .go_back {
    width: 80px;
    height: 50px;
    background: #ffffff;
    border: 1px solid #6345d5;
    border-radius: 6px;
    color: #6345d5;
  }
}
</style>
